/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MentionListComponent as ɵa} from './lib/mention-list.component';